// Function loadHorizontalScrollBlock loads the HorizontalScrollBlock class by dynamically importing the js on demand if needed

export function loadHorizontalScrollBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-horizontal-scroll-block-chunk" */ '../widgets/horizontalScrollBlock').then(wg => {

		const { HorizontalScrollBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="HorizontalScrollBlock"]');

		if(!$wg) {
			// console.info('HorizontalScrollBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="HorizontalScrollBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new HorizontalScrollBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new HorizontalScrollBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the HorizontalScrollBlock widget');

}
